import React from 'react'
import {CreateAccount} from "../../components/CreateAccount";
import {Header} from "../../components/Header";
import {Container, StyledMedia} from "../../styles/CommonStyler"
import Footer from "../../components/Footer";
import {isMobileOnly} from "react-device-detect";

// COMPONENT ##########################################################

const Registration = ({}) => {
    return (
        <StyledMedia>
          <Container isMobile={isMobileOnly}>

            <Header/>

            <CreateAccount/>

            <Footer />

          </Container>
        </StyledMedia>
    )
};

export default Registration;